import style from "./style.module.css";

export default function InputColor(props) {
  const { value, required } = props;

  return (
    <div className={style.color_container}>
      <input data-required={required} data-required-valid={required && !!value} type="text" {...props} />
      <div className={style.color_preview} style={{ backgroundColor: value }}></div>
    </div>
  );
}
